export class URLParams {
  constructor() {
    let urlParams = new URLSearchParams(window.location.search);
    let userid = urlParams.get("userid");
    const state = urlParams.get("state");
    this.urlParams = {
      userid,
      jumpToTime: urlParams.get("jumpToTime"),
    };
    window.localStorage.setItem("uid", userid);
    window.localStorage.setItem("state", state);
  }

  get = (param) => this.urlParams && this.urlParams[param];
}
